// @/services/CoursesClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const resultsOptions = {
  baseUrl: `${BACK_END_URL}/result`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class ResultsClient extends CandyClient {
  constructor() {
    super(resultsOptions);
  }

  // Create
  async submitQuiz(dto) {
    const token = getToken();
  
    return this.post("/submit", dto, {
      customHeaders: { Authorization: `Bearer ${token}` ,
      'Content-Type': 'application/json'
      }
    });
  }  


}